import { ValidationResult } from './getValidator';

const noSpaceRegex = /^\S*$/;
const lowercaseRegex = /[a-z]/;
const uppercaseRegex = /[A-Z]/;
const specialCharacterRegex = /[!@#$%^&*]/;

const validatePassword = (value: string): ValidationResult => {
  if (!value.length) {
    return { key: 'required' };
  } else if (value.length < 8) {
    return { key: 'minLength', values: { minLength: 8 } };
  } else if (value.length > 70) {
    return { key: 'maxLength', values: { maxLength: 70 } };
  } else if (!lowercaseRegex.test(value)) {
    return { key: 'password.lowercaseLetter' };
  } else if (!uppercaseRegex.test(value)) {
    return { key: 'password.uppercaseLetter' };
  } else if (!specialCharacterRegex.test(value)) {
    return { key: 'password.specialCharacter' };
  } else if (!noSpaceRegex.test(value)) {
    return { key: 'password.noSpaces' };
  } else {
    return undefined;
  }
};

export default validatePassword;
